module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('div', {
    staticClass: "danwei-warp"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.danwei))]), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v(_vm._s(_vm.row.saiqu.name))]), _vm._v(" "), _c('div', {
    staticClass: "duiwu"
  }, [_vm._v(_vm._s(_vm.row.mingcheng))]), _vm._v(" "), (_vm.row.saiqu.erweiimg.length > 0) ? _c('img', {
    staticStyle: {
      "width": "200px",
      "margin-top": "20px"
    },
    attrs: {
      "src": _vm.row.saiqu.erweiimg[0].url
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.saiqu.erweiimg.length > 0) ? _c('p', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v(_vm._s(_vm.row.saiqu.name)), _c('br'), _vm._v("扫码加工作人员好友，进入赛事微信群")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "step-warp"
  }, [_c('van-steps', {
    attrs: {
      "direction": "vertical",
      "active-color": "#00B388",
      "active": _vm.active
    }
  }, [_c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("填写队伍信息")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("完善队伍信息")]), _vm._v(" "), (_vm.row.memberstatus > 0 && _vm.row.memberstatus < 5) ? _c('div', {
    staticClass: "right tiny-btn-0",
    on: {
      "click": function($event) {
        return _vm.goStep1()
      }
    }
  }, [_vm._v("修改信息")]) : _vm._e()])]), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("完善项目信息")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("选择项目以及相关运动员")]), _vm._v(" "), (_vm.row.memberstatus > 1 && _vm.row.memberstatus < 5) ? _c('div', {
    staticClass: "right tiny-btn-0",
    on: {
      "click": function($event) {
        return _vm.goStep2()
      }
    }
  }, [_vm._v("修改信息")]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus > 1 && _vm.row.saiqu.is_jizan == 2) ? _c('div', {
    staticClass: "right tiny-btn-1",
    staticStyle: {
      "right": "80px"
    },
    on: {
      "click": function($event) {
        _vm.musicUrlShow = true
      }
    }
  }, [_vm._v("上传/修改音乐")]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 1) ? _c('div', {
    staticClass: "right tiny-btn-1",
    on: {
      "click": function($event) {
        return _vm.goStep2()
      }
    }
  }, [_vm._v("继续操作")]) : _vm._e()])]), _vm._v(" "), (_vm.row.saiqu.is_online == 2 || _vm.row.saiqu.is_online == 3) ? _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("选择食宿行服务")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("完善随行人员及房间信息")]), _vm._v(" "), (_vm.row.memberstatus > 2 && _vm.row.memberstatus != 6) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep3',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep3',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-0"
  }, [_vm._v("修改信息")]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 2) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep3',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep3',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-1"
  }, [_vm._v("继续操作")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.row.saiqu.is_jizan == 2) ? _c('van-step', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ([751, 767].indexOf(parseInt(_vm.row.saiqu.id)) == -1),
      expression: "[751,767].indexOf(parseInt(row.saiqu.id))==-1"
    }]
  }, [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("确认订单并支付")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("完善发票信息，支付费用")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyAddress',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyAddress',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-0",
    staticStyle: {
      "right": "80px"
    }
  }, [_vm._v("邮寄地址")]), _vm._v(" "), (_vm.row.memberstatus == 4 || _vm.row.memberstatus == 5) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep5',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep5',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-1"
  }, [_vm._v("支付费用")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.row.saiqu.is_jiesong == 1) ? _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("抵/离酒店时间")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("抵/离酒店时间信息填写")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'saiConfirmDetail4',
        query: {
          id: _vm.row.id,
          from: 'app'
        }
      }),
      expression: "{name:'saiConfirmDetail4',query:{id:row.id,from:'app'}}"
    }],
    staticClass: "right tiny-btn-0",
    staticStyle: {
      "right": "80px"
    }
  }, [_vm._v("到达时间")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'saiConfirmDetail5',
        query: {
          id: _vm.row.id,
          from: 'app'
        }
      }),
      expression: "{name:'saiConfirmDetail5',query:{id:row.id,from:'app'}}"
    }],
    staticClass: "right tiny-btn-0"
  }, [_vm._v("离开时间")])])]) : _vm._e(), _vm._v(" "), _c('van-step', [_c('div', {
    staticClass: "step-li"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("报名成功")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("报名成功")]), _vm._v(" "), ((_vm.row.memberstatus == 6 || _vm.row.memberstatus == -2) && _vm.row.saiqu.need_video == 1 && !_vm.row.video_ok) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyVideoList',
        query: {
          id: _vm.row.id,
          from: 'app'
        }
      }),
      expression: "{name:'ISaiApplyVideoList',query:{id:row.id,from:'app'}}"
    }],
    staticClass: "right tiny-btn-0",
    staticStyle: {
      "right": "100px"
    }
  }, [_vm._v("上传视频")]) : _vm._e(), _vm._v(" "), ((_vm.row.memberstatus == 6 || _vm.row.memberstatus == -2) && _vm.row.saiqu.need_video == 1 && _vm.row.video_ok) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyVideoList',
        query: {
          id: _vm.row.id,
          from: 'app'
        }
      }),
      expression: "{name:'ISaiApplyVideoList',query:{id:row.id,from:'app'}}"
    }],
    staticClass: "right tiny-btn-0",
    staticStyle: {
      "right": "100px"
    }
  }, [_vm._v("视频已上传")]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 6 && _vm.row.saiqu.is_jizan == 1 && !_vm.row.jizan_ok) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ZSaiApplyZanList',
        query: {
          id: _vm.row.id,
          from: 'app'
        }
      }),
      expression: "{name:'ZSaiApplyZanList',query:{id:row.id,from:'app'}}"
    }],
    staticClass: "right tiny-btn-0"
  }, [_vm._v("上传集赞")]) : _vm._e(), _vm._v(" "), (_vm.row.memberstatus == 6 && _vm.row.saiqu.is_jizan == 1 && _vm.row.jizan_ok) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ZSaiApplyZanList',
        query: {
          id: _vm.row.id,
          from: 'app'
        }
      }),
      expression: "{name:'ZSaiApplyZanList',query:{id:row.id,from:'app'}}"
    }],
    staticClass: "right tiny-btn-0"
  }, [_vm._v("集赞已上传")]) : _vm._e(), _vm._v(" "), (_vm.row.have_cert) ? _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiCertList',
        query: {
          id: _vm.row.id
        }
      }),
      expression: "{name:'ISaiCertList',query:{id:row.id}}"
    }],
    staticClass: "right tiny-btn-1",
    staticStyle: {
      "top": "30px"
    }
  }, [_vm._v("下载证书")]) : _vm._e()])])], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "请在复制网址到电脑端操作",
      "confirm-button-text": "关闭"
    },
    model: {
      value: (_vm.musicUrlShow),
      callback: function($$v) {
        _vm.musicUrlShow = $$v
      },
      expression: "musicUrlShow"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px 0",
      "line-height": "30px"
    }
  }, [_c('div', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.row.music_edit_url),
      expression: "row.music_edit_url",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }]
  }, [_vm._v("\n                    " + _vm._s(_vm.row.music_edit_url) + "  "), _c('br'), _vm._v(" "), _c('span', [_vm._v("复制")])])])]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.ltActions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "select": _vm.onLtSelect,
      "cancel": function($event) {
        _vm.ltShow = false
      }
    },
    model: {
      value: (_vm.ltShow),
      callback: function($$v) {
        _vm.ltShow = $$v
      },
      expression: "ltShow"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-229dedca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyDetailDianxin.vue
// module id = 2271
// module chunks = 0